export const InsuranceStatus = {
  ACTIVE: 'Active',
  SUSPENDED: 'Paused',
  SCHEDULED: 'Scheduled',
  INACTIVE: 'Inactive',
  EXPIRED: 'Expired',
  CANCELED: 'Canceled',
}
